import { styled } from "@vitality-ds/system";
import BaseSidebarBarStyles from "./styles/BaseSidebarBar.styles";
import BaseSidebarContentStyles from "./styles/BaseSidebarContent.styles";
export var BaseSidebarBar = styled("aside", BaseSidebarBarStyles);
export var BaseSidebarContent = styled("div", BaseSidebarContentStyles);